import { useFetchListData, useMutationData } from '@/composables'
import { http } from '@/utils'
import { defineStore } from 'pinia'
import { computed } from 'vue'
import type { LeveragePayload } from './types'

const useLeverageStore = defineStore('leverage', () => {
  const { data, loading, fetchData } = useFetchListData<string[]>({
    url: '/api/pub/get_leverage',
    autoFetch: false,
    showErrorMessage: false,
  })

  const { loading: changeLeverageLoading, execute } = useMutationData<[LeveragePayload], void>(
    async (payload) => await http.post('/api/exchange/change_leverage', payload),
  )

  const leverageOptions = computed(() => {
    if (!data.value) return []
    return data.value.map((item: string) => {
      return { label: `1:${item}`, value: item }
    })
  })

  const changeMaxLeverage = async (payload: LeveragePayload) => {
    try {
      await execute(payload)
      await fetchData()
    } catch (error) {
      console.error(error)
    }
  }

  const reset = () => {
    loading.value = false
    data.value = null
    _initPromise = null
  }

  // Idempotent initializer
  let _initPromise: Promise<void> | null = null
  const init = async (params?: Record<string, any>) => {
    if (_initPromise) return _initPromise
    _initPromise = (async () => {
      if (Array.isArray(data.value) && data.value.length > 0) return
      await fetchData(params)
    })()
    return _initPromise
  }

  return {
    loading,
    changeLeverageLoading,
    data,
    leverageOptions,
    reset,
    init,
    fetchData,
    changeMaxLeverage,
  }
})

export default useLeverageStore
export { useLeverageStore }
